import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import dayjs from "utils/dayjs";

const APP_TIMEZONE = process.env.REACT_APP_TIMEZONE || 'Asia/Seoul';

function TodayAll() {
  const { t } = useTranslation();
  
  // 1. 상태를 하나로 관리하여 리렌더링 최적화
  const [now, setNow] = useState(() => dayjs().tz(APP_TIMEZONE));

  useEffect(() => {
    // 2. 1초마다 타임존 기반 현재 시간으로 업데이트
    const timer = setInterval(() => {
      setNow(dayjs().tz(APP_TIMEZONE));
    // console.log("Dayjs locale changed to:", dayjs.locale());
    }, 1000);

    // 3. 컴포넌트 언마운트 시 인터벌 제거 (메모리 누수 방지)
    return () => clearInterval(timer);
  }, []);

  // 4. 요일 및 포맷팅 처리
  const dayOfWeek = t(`message.common.text.${now.format('dddd').toLowerCase()}`); 
  // 요일은 dddd 포맷을 쓰거나 기존처럼 배열을 써도 되지만, 
  // dayjs의 format('YYYY-M-D (ddd) HH:mm:ss') 기능을 활용하면 훨씬 간단합니다.

  return (
    <>
      <h6 className="timeline" style={{ marginTop: "5px" }}>
        {now.format('YYYY-M-D')} ({now.format('ddd')}) {now.format('HH:mm:ss')}
      </h6>
    </>
  );
}

export default TodayAll;